import { render, staticRenderFns } from "./Second.vue?vue&type=template&id=883e8dc8&scoped=true"
import script from "./Second.vue?vue&type=script&lang=js"
export * from "./Second.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883e8dc8",
  null
  
)

export default component.exports